// extracted by mini-css-extract-plugin
export var checkbox = "style-module--checkbox--0bd2f";
export var checkboxLabel = "style-module--checkboxLabel--3c71f";
export var checkboxRow = "style-module--checkboxRow--864cd";